import { useReducer } from 'react'

const useForceUpdate = (go = true) => {
  const [, forceUpdate] = useReducer(x => x + 1, 0)

  return go ? forceUpdate : () => {}
}

export default useForceUpdate
